module.exports = {
    EEOP: '/health-eeop',
    CATERING: '/health-catering'
}


// WEBPACK FOOTER //
// ./src/api/context.js